/**
 * CBA API client.
 *
 * Routes through the Vite proxy:
 *   /v1/cba/* -> cba-api:8004
 *
 * Note: the axios client in ./client.js unwraps .data automatically
 * via the response interceptor, so mutationFn receives the parsed JSON
 * body directly (not an axios response object).
 */

import client from './client';

export const cbaAPI = {
  /**
   * Run a Cost-Benefit Analysis.
   *
   * @param {object} data - Request body conforming to the CBA API schema.
   * @returns {Promise<object>} Parsed CBA result JSON.
   */
  calculate: (data) => client.post('/v1/cba/calculate', data),
};
